// Прокрутка внутри контейнера без прокрутки страницы.
// scrollIntoView двигает и все родительские области, включая окно: полоса месяцев внизу страницы
// утаскивала экран мимо выдачи билетов. Здесь меняется только scrollLeft/scrollTop самого контейнера.

/** Поставить элемент по центру горизонтальной полосы */
export function centerInStrip(strip: HTMLElement | null | undefined, item: Element | null | undefined): void {
  if (!strip || !item) return;
  const s = strip.getBoundingClientRect();
  const i = item.getBoundingClientRect();
  strip.scrollLeft += i.left - s.left - (s.width - i.width) / 2;
}

/** Показать элемент в вертикальном списке (меню), если он вне видимой части */
export function keepInList(list: HTMLElement | null | undefined, item: Element | null | undefined): void {
  if (!list || !item) return;
  const l = list.getBoundingClientRect();
  const i = item.getBoundingClientRect();
  if (i.top < l.top) list.scrollTop -= l.top - i.top;
  else if (i.bottom > l.bottom) list.scrollTop += i.bottom - l.bottom;
}

/** Телефон: после поиска прокрутить к выдаче раздела (форма в шапке занимает весь экран) */
export function scrollToResults(tab: string): void {
  if (typeof matchMedia !== 'function' || !matchMedia('(max-width: 760px)').matches) return;
  requestAnimationFrame(() => {
    const el = document.querySelector<HTMLElement>(`main [data-panel="${tab}"]`);
    if (!el || el.hidden) return;
    const header = document.querySelector('.topbar')?.getBoundingClientRect().height || 56;
    try { window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - header - 8, behavior: 'smooth' }); } catch { /* jsdom */ }
  });
}
